import { useState } from 'react'
import { Box, Checkbox, IconButton, TableCell, TableRow, Typography, useTheme } from '@mui/material'
import moment from 'moment'

import EditIcon from '@mui/icons-material/Edit'
import DownloadIcon from '@mui/icons-material/Download'

import { UpdateChallengeForm } from '../forms/update/form-wrapper.component'
import { HelperWrapper } from 'src/components/helper-wrapper'

import { useMe, useTableItemsCheck } from 'src/hooks'
import { IChallengesBaseWithId, IChallengesWithAdditionalData } from 'src/types'
import { UtcAndLocalDatesCell } from 'src/components/utc-and-local-dates-cell'

interface IProps
  extends Pick<ReturnType<typeof useTableItemsCheck>, 'isItemSelected' | 'handleItemCheck'> {
  row: IChallengesWithAdditionalData
  handleDownloadCsv: (params: IChallengesBaseWithId) => Promise<void>
}

export const TableItem = ({ row, isItemSelected, handleItemCheck, handleDownloadCsv }: IProps) => {
  const { data: user } = useMe()

  const [open, setOpen] = useState(false)

  const handleOpen = () => setOpen(true)
  const handleClose = () => setOpen(false)

  const handleDownload = async () => {
    await handleDownloadCsv(row)
  }

  const theme = useTheme()

  return (
    <>
      <TableRow>
        <TableCell align="center">
          <Checkbox
            disabled={row.paid}
            checked={isItemSelected(row.id)}
            onChange={handleItemCheck(row.id)}
            sx={{ color: theme.palette.custom.grey2 }}
          />
        </TableCell>
        <TableCell sx={{ minWidth: '150px' }}>
          <Typography>{row.name}</Typography>
          {row?.pending_scans_to_approve && row?.pending_scans_to_approve != 0 ? (
            <Box sx={{ mt: '3px' }}>
              <Typography variant="caption" color="error">
                {row.pending_scans_to_approve} Pending Scans
              </Typography>
            </Box>
          ) : null}
        </TableCell>
        <TableCell>{row.description}</TableCell>
        <TableCell align="center">{row.trai_pool}</TableCell>
        <TableCell align="center">
          {row.paid ? <HelperWrapper t="yes-label" /> : <HelperWrapper t="no-label" />}
        </TableCell>
        <TableCell align="center">
          <UtcAndLocalDatesCell date={row.start_date} loalTimezone={user?.timezone} />
        </TableCell>
        <TableCell align="center" sx={{ fontSize: '11px' }}>
          <UtcAndLocalDatesCell date={row.end_date} loalTimezone={user?.timezone} />
        </TableCell>
        <TableCell align="center" sx={{ fontSize: '11px' }}>
          <UtcAndLocalDatesCell date={row.created_at} loalTimezone={user?.timezone} />
        </TableCell>
        <TableCell align="center">
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '2px' }}>
            <IconButton onClick={handleOpen} disabled={row.paid}>
              <EditIcon />
            </IconButton>
            <IconButton onClick={handleDownload}>
              <DownloadIcon />
            </IconButton>
          </Box>
        </TableCell>
      </TableRow>
      <UpdateChallengeForm
        handleClose={handleClose}
        open={open}
        id={row.id}
        initial={{
          name: row.name,
          description: row.description,
          start_date: moment(row.start_date),
          end_date: moment(row.end_date),
          paid: row.paid,
          trai_pool: Number(row.trai_pool),
        }}
      />
    </>
  )
}
